/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".sell-all-message[_ngcontent-%COMP%]{max-width:450px}td.right-align[_ngcontent-%COMP%]{text-align:right}.basis[_ngcontent-%COMP%]{display:flex}"];
export { styles as styles };
